// extracted by mini-css-extract-plugin
export default {"disabledLink":"styles_disabledLink__ducWf"};